
// Unsubscribed Email 
export const UNSUBSCRIBED_EMAIL = "UNSUBSCRIBED_EMAIL"
export const UNSUBSCRIBED_EMAIL_SUCCESS = "UNSUBSCRIBED_EMAIL_SUCCESS"
export const UNSUBSCRIBED_EMAIL_FAILED = "UNSUBSCRIBED_EMAIL_FAILED"

// subscribed Email 
export const SUBSCRIBED_EMAIL = "SUBSCRIBED_EMAIL"